import React, { useState, useRef } from 'react';
import './NewsSection.css';
import k2Image from '../assets/k2.jpg';
import k1Image from '../assets/k1.jpg';
import k3Image from '../assets/k3.jpg';

const NewsSection: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef<HTMLDivElement>(null);

  const newsItems = [
    {
      date: "July 1, 2025",
      headline: "🏆 CHAMPIONS! Kavodax Wins CodeLaunch Canada 2025 - Sweeping Both Judges' Choice AND Audience Favorite!",
      link: "https://www.linkedin.com/feed/update/urn:li:activity:7344392402582888450/",
      image: k2Image,
      alt: "Kavodax Champions at CodeLaunch Canada 2025"
    },
    {
      date: "July 3, 2025",
      headline: "🚀 Kavodax Joins The Landing-Pad Accelerator Program with Spark Centre! $10,000 grant + $10,000 co-investment to drive growth.",
      link: "https://www.linkedin.com/feed/update/urn:li:activity:7344806134890823680/",
      image: k1Image,
      alt: "Kavodax Landing-Pad Accelerator Program"
    },
    {
      date: "July 10, 2025",
      headline: "🚀 Kavodax Joins OVHcloud with $20K in Cloud Credits - Building the Future of Fintech Together!",
      link: "https://www.linkedin.com/feed/update/urn:li:activity:7346337883663781888/",
      image: k3Image, 
      alt: "Kavodax OVHcloud Startup Program Partnership"
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % newsItems.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + newsItems.length) % newsItems.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <section className="news-section">
      <div className="container">
        <div className="news-layout">
          <div className="section-title">
            <h2>Latest News</h2>
            <p>Stay updated with Kavodax's latest achievements and announcements</p>
          </div>
          
          <div className="news-container">
            <div className="news-slider">
              <div className="slider-controls">
                <button 
                  className="slider-btn prev-btn" 
                  onClick={prevSlide}
                  aria-label="Previous news item"
                >
                  ←
                </button>
                <button 
                  className="slider-btn next-btn" 
                  onClick={nextSlide}
                  aria-label="Next news item"
                >
                  →
                </button>
              </div>
              
              <div className="news-slider-container" ref={sliderRef}>
                <div 
                  className="news-slides"
                  style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                >
                  {newsItems.map((item, index) => (
                    <div key={index} className="news-card">
                      <div className="news-image">
                        <img src={item.image} alt={item.alt} />
                      </div>
                      <div className="news-content">
                        <div className="news-date">{item.date}</div>
                        <h3 className="news-headline">{item.headline}</h3>
                        <a 
                          href={item.link} 
                          target="_blank" 
                          rel="noopener noreferrer" 
                          className="btn btn-secondary"
                        >
                          Read More
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              <div className="slider-dots">
                {newsItems.map((_, index) => (
                  <button
                    key={index}
                    className={`dot ${currentSlide === index ? 'active' : ''}`}
                    onClick={() => goToSlide(index)}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsSection; 